import React, { useEffect, useState } from "react";
import {
  getGmailCredentials,
  updateGmailCredentials,
} from "services/GmailService";
import PageTitle from "jsx/layouts/PageTitle";
import {
  notifyError,
  notifySuccess,
} from "jsx/components/CitoPlus/components/CitoPlusToastr";

const GmailSettings = () => {
  const [form, setForm] = useState({
    gmail_email: "",
    gmail_app_password: "",
  });
  const [hasPassword, setHasPassword] = useState(false);
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const loadData = async () => {
    try {
      setLoading(true);
      const data = await getGmailCredentials();
      setForm((prev) => ({
        ...prev,
        gmail_email: data.gmail_email || "",
        gmail_app_password: "",
      }));
      setHasPassword(Boolean(data.has_app_password));
      setUpdatedAt(data.gmail_config_updated_at);
      setError("");
    } catch (err) {
      setError("No se pudo cargar la configuración de Gmail.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    try {
      const payload = {
        gmail_email: form.gmail_email || null,
      };
      // Only send password if user typed something
      if (form.gmail_app_password !== "") {
        payload.gmail_app_password = form.gmail_app_password;
      }
      const data = await updateGmailCredentials(payload);
      setHasPassword(Boolean(data.has_app_password));
      setUpdatedAt(data.gmail_config_updated_at);
      setForm((prev) => ({ ...prev, gmail_app_password: "" }));
      notifySuccess("Configuración de Gmail guardada.");
    } catch (err) {
      setError("No se pudo guardar la configuración de Gmail.");
      notifyError("No se pudo guardar la configuración de Gmail.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <PageTitle
          headingPara="Configura tu correo y contraseña de aplicación de Gmail para envíos."
          motherMenu="Mi cuenta"
          activeMenu="Gmail (envío de correo)"
        />
      </div>
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Gmail como gateway</h4>
          </div>
          <div className="card-body">
            {loading ? (
              <p>Cargando...</p>
            ) : (
              <form onSubmit={handleSubmit}>
                {error && <div className="alert alert-danger">{error}</div>}

                <div className="form-group mb-3">
                  <label htmlFor="gmail_email">Correo Gmail</label>
                  <input
                    type="email"
                    id="gmail_email"
                    name="gmail_email"
                    className="form-control"
                    value={form.gmail_email}
                    onChange={handleChange}
                    placeholder="tu_correo@gmail.com"
                    required
                  />
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="gmail_app_password">
                    Contraseña de aplicación
                  </label>
                  <input
                    type="password"
                    id="gmail_app_password"
                    name="gmail_app_password"
                    className="form-control"
                    value={form.gmail_app_password}
                    onChange={handleChange}
                    placeholder="16 caracteres de la contraseña de aplicación"
                  />
                  <small className="form-text text-muted">
                    Genera la contraseña de aplicación en tu cuenta de Google
                    (Seguridad &gt; Verificación en dos pasos &gt; Contraseñas
                    de aplicación). Déjalo vacío si no quieres cambiarla.
                  </small>
                </div>

                <div className="form-group mb-3">
                  <div className="d-flex flex-column">
                    <span>
                      Contraseña de aplicación configurada:{" "}
                      <strong>{hasPassword ? "Sí" : "No"}</strong>
                    </span>
                    {updatedAt && (
                      <small className="text-muted">
                        Última actualización: {updatedAt}
                      </small>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={saving}
                  >
                    {saving ? "Guardando..." : "Guardar Gmail"}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GmailSettings;
